import { render, staticRenderFns } from "./BuroPersonelList.vue?vue&type=template&id=20183586"
import script from "./BuroPersonelList.vue?vue&type=script&lang=ts"
export * from "./BuroPersonelList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports